import { UserRole } from "@/core/api/apiClient";

const mapping: Record<UserRole, string> = {
  SystemUser: "System User",
  Dispatcher: "Dispatcher",
  Driver: "Driver",
  Administrator: "Administrator"
};

export function mapUserRole(key: UserRole | string): string {
  return mapping[key as UserRole] ?? key;
}

export default mapUserRole;
